import axios from "axios";

async function getValidToken() {
  let token = localStorage.getItem("token");
  // Intenta una llamada de prueba para verificar si el token es válido
  try {
    await axios.get("https://www.googleapis.com/drive/v3/about?fields=user", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return token;
  } catch (error) {
    if (error.response?.status === 401) {
      return await refreshToken();
    }
    throw error;
  }
}

async function refreshToken() {
  const response = await axios.post("https://oauth2.googleapis.com/token", {
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
        refresh_token: process.env.REACT_APP_OAUTH_REFRESH_TOKEN,
        grant_type: "refresh_token",
  });
  const newToken = response.data.access_token;
  localStorage.setItem("token", newToken);
  return newToken;
}

export async function uploadReportToDrive(file) {
  const token = await getValidToken();
  const folderId = process.env.REACT_APP_GOOGLE_DRIVE_REPORTS_FOLDER_ID;

  console.log("folderId:", process.env.REACT_APP_GOOGLE_DRIVE_REPORTS_FOLDER_ID);
  
  const metadata = {
    name: file.name,
    parents: [folderId],
  };

  const form = new FormData();
  form.append(
    "metadata",
    new Blob([JSON.stringify(metadata)], { type: "application/json; charset=UTF-8" }) // ← charset añadido
  );
  form.append("file", file);

  const response = await axios.post(
    "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
    form,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": undefined, // ← deja que el navegador ponga el boundary correcto
      },
    }
  );

  return response.data;
}